import { useQuery } from 'react-query';
import { FileTypes } from 'taboola-ultimate-ui';
import { modifyExternalUrl } from 'modules/campaigns/services/utils';
import { aiGenerationApi } from 'services/api';

export const useFetchAIGeneratedMotion = ({ imageUrl, accountId, setVideos, isRegenerated, motionParams }) => {
    return useQuery(
        ['fetchAIGeneratedMotion'],
        async () => {
            try {
                const { prompt, ...motionOptions } = motionParams || {};
                const { video, message } = await aiGenerationApi.getAIGeneratedMotionFromImage({
                    accountId,
                    imageUrl,
                    isRegenerated,
                    inputTextPrompt: prompt,
                    promptHelperParams: motionOptions,
                });
                if (message) {
                    throw new Error(message);
                }
                const thumbnailUrl = modifyExternalUrl(video.fallbackImageUrl);
                return {
                    result: {
                        url: video.url,
                        thumbnailUrl,
                        id: modifyExternalUrl(video.url),
                        fileType: FileTypes.VIDEO,
                    },
                };
            } catch (error) {
                throw error;
            }
        },
        {
            enabled: false,
            onSuccess: data => {
                setVideos(prev => [...prev, data.result]);
            },
            retry: 1,
            refetchOnWindowFocus: false,
        }
    );
};
